export default "__VITE_ASSET__BXOBJu8s__"